import React from "react";

interface ReconciledFilterLabelProps {
    filters: {
        isReconciled?: boolean;
        isNotReconciled?: boolean;
    };
}

export const ReconciledFilterLabel: React.FC<ReconciledFilterLabelProps> = ({
    filters: { isReconciled, isNotReconciled },
}) => {
    if (isReconciled && !isNotReconciled) {
        return <>Reconciled</>;
    }

    if (!isReconciled && isNotReconciled) {
        return <>Not reconciled</>;
    }
};
